import axios from "axios";
axios.defaults.timeout = 3600000 

export default {
  getPeelhuntSectorsNameList() {
    return axios.get(
      `${process.env.VUE_APP_DOMAIN_URL}/peelhuntdotnet/fs/api/PeelHunt/GetSectorMaster`
    );
  },
  getCustomIndexDropdown() {
    return axios.get(
      `${process.env.VUE_APP_DOMAIN_URL}/peelhuntdotnet/fs/api/PeelHunt/GetCustomIndexComboFill`
    );
  },
  getPeelhuntTableList(data) {
    return axios.get(
      `${process.env.VUE_APP_DOMAIN_URL}/peelhuntdotnet/fs/api/PeelHunt/GetCompanyDetails?SectorId=` +
        data.SectorID
    );
  },
  getPeelhuntCustomIndexData(data) {
    return axios.post(
      `${process.env.VUE_APP_DOMAIN_URL}/peelhuntdotnet/fs/api/PeelHunt/GetCustomIndex`, data
    );
  },
  getPeelhuntPricePerformanceData(data, url) {
    return axios.post(
      `${process.env.VUE_APP_DOMAIN_URL}/peelhuntdotnet/fs/api/PeelHunt/${url}`, data
    );
  },
};
